import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { locationReducer } from "./locationReducer";
import { invoiceReducer } from "./invoiceReducer";
export default combineReducers({
  auth: authReducer,
  location: locationReducer,
  invoice: invoiceReducer
});
